module.exports = __webpack_public_path__ + "assets/f719325a4f94c585a04056cf6002a4be.svg";